<template>
  <services-table
    :apiURL="apiURL"
    :title="title"
    :message="message"
    :type="type"
    :bus="bus"
  >
  </services-table>
</template>

<script>
import { mapGetters } from 'vuex';
import Vue from 'vue';
import ServicesTable from '~/components/ServicesTable';

export default {
  middleware: 'auth',
  metaInfo() {
    return { title: this.$t('services') };
  },
  props: {
    id: { default: '' },
    action: { default: '' },
  },
  data: () => ({
    name: '',
    service: '',
    servicesList: [],
    serviceAmount: 1,
    showAdd: false,
    loadServices: false,
    message: '',
    type: '',
    bus: new Vue(),
  }),
  computed: {
    apiURL() {
      return `/api/catalogs/dealers/${this.user.dealer_id}/licences`;
    },
    title() {
      return 'Servicios';
    },
    ...mapGetters({
      user: 'auth/user',
    }),
  },
  components: {
    ServicesTable,
  },
};
</script>
